import { ComponentProps, forwardRef } from "react";
import { useRHFAdapter } from "@shared/features/form/useRHFAdapter";
import {
  FieldBaseProps,
  useFieldProps,
} from "@shared/features/form/useFieldProps";

export type Props = ComponentProps<"textarea"> &
  FieldBaseProps & {
    name: string;
    errorMessage?: string;
  };

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      name,
      className,
      error,
      prefix,
      isWithIcon,
      required,
      isLoading,
      isSubmitting,
      onChange,
      onBlur,
    },
    ref
  ) => {
    const { inputProps } = useRHFAdapter({
      name,
      onChange,
      onBlur,
    });

    const fieldProps = useFieldProps({
      className,
      error,
      isLoading,
      isSubmitting,
      required,
      isWithIcon,
      prefix,
    });

    return (
      <textarea
        name={name}
        id={name}
        {...inputProps}
        {...fieldProps}
        data-testid={`textarea-${name}`}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;
